export default "__VITE_ASSET__16b6e35e__"